import type { Background } from '@/types/sanity/content';
import createImageUrlBuilder from '@sanity/image-url';
import type { SanityImageSource } from '@sanity/image-url/lib/types/types';
export const SANITY_PROJECT_ID = 'xswtsnqo';
export const SANITY_DATASET = import.meta.env.MODE === 'development' ? 'test' : 'production';
export const SANITY_API_VERSION = '2024-01-01';

const builder = createImageUrlBuilder({
  dataset: SANITY_DATASET,
  projectId: SANITY_PROJECT_ID,
});

export const urlFor = (source: SanityImageSource) => {
  return builder.image(source);
};

export const getBackgroundStyles = (background: Background) => {
  if (!background) return {};

  if (background.type === 'color') {
    if (background.color?.includes('linear')) {
      return {
        background: background.color,
      };
    }
    return {
      backgroundColor: background.color,
    };
  }

  if (background.type === 'image' && background.backgroundImage) {
    const desktopImageUrl = urlFor(background.backgroundImage).url();

    return {
      backgroundImage: `url(${desktopImageUrl})`,
      backgroundPosition: background.position || 'center',
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'cover',
    };
  }

  return {};
};
